import { COOKIES } from "@/constants/cookies";
import { DEFAULT_ROUTES } from "@/constants/routes";
import { destroyCookie } from "nookies";
import { useNavigate } from "react-router-dom";

export const useLogout = () => {
  const navigate = useNavigate();

  function handleLogout() {
    destroyCookie(undefined, COOKIES.BACKOFFICE_AUTH, {
      path: "/",
      domain: "woba.com.br",
    });
    navigate(DEFAULT_ROUTES.SIGNIN);
  }

  return {
    handleLogout,
  };
};
